<div class="row" style="margin-bottom: 20px; margin-top: 30px">
  <div *ngIf="config.editMode && userService.userHasChampUpdatePermissionAccess(config.name,config.typeName)"
    class="col-lg-11" style="padding-left: 0px">
    <ng-container *ngIf="config.label">
      <label [for]="config.id"><strong>{{ config.label }}</strong></label></ng-container><br />
    <mat-form-field appearance="outline" appearance="outline" style="font-size: 10px; width: 100%"
      *ngIf="!onlyOneValue && !hideAutocomplete">
      <input matInput type="text" [name]="config.label" (ngModelChange)="autocompleteSearch($event)"
        [matAutocomplete]="auto" [placeholder]="config.label" [formControl]="searchArticlesCtrl" />
      <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [panelWidth]="570">
        <mat-option *ngFor="let value of filteredArticles" [value]="getValue(value)" (click)="addItem(value)">
          <ng-container *ngIf="value?.[config.referenceField]">
            <ng-container *ngIf="value?.nameCategory; else defaultRef">
              <span style="background-color: #e0e0e0; border-radius: var(--bs-border-radius-sm); padding: 2px 8px; font-size: 12px; color: #555; margin-right: 5px;">{{ getValue(value?.[config.referenceField])}}</span>
              {{ getValue(value?.nameCategory) }}
            </ng-container>
            <ng-template #defaultRef>
              {{ getValue(value?.[config.referenceField])}}
            </ng-template>
          </ng-container>
          <ng-container *ngIf="value?.nom">
            {{ value?.nom}}
          </ng-container>
          <ng-container *ngIf="value?.email">
            {{ value?.email }}
          </ng-container>
          <!-- <ng-container *ngIf="value.titre && !value.nom">
            {{ value.titre }}
          </ng-container> -->
          <ng-container *ngIf="!value?.titre && !value?.nom">
            {{ value?.reference }}
          </ng-container>
          <ng-container *ngIf="value?.code && !value?.maplocaletitre && !value?.[config.referenceField]">
            {{ value?.code }}
          </ng-container>
          <ng-container *ngIf="value?.code && value?.maplocaletitre && !value?.[config.referenceField]">
            {{ value?.code }} - {{ value?.maplocaletitre?.[locales[0]] }}
          </ng-container>
          <!-- <ng-container *ngIf="value.code && value.titre && !value.maplocaletitre">
            {{ value.code }} - {{ value.titre }}
          </ng-container> -->
          <!-- <ng-container *ngIf="value.code && !value.titre">
            {{ value.code }}
          </ng-container> -->

          <ng-container *ngIf="value?.label && entite !== 'Picto'">
            {{ value?.label }}
          </ng-container>
          <ng-container *ngIf="value?.label && entite === 'Picto'">
            {{ value?.label?.[locales[0]] }}
          </ng-container>

          <ng-container *ngIf="value?.mapDescriptionVl">
            {{ value?.mapDescriptionVl?.[locales[0]]}}
          </ng-container>
          <ng-container *ngIf="value?.mapdescription">
            {{ value?.mapdescription?.[locales[0]]}}
          </ng-container>
          <ng-container *ngIf="value?.maplocaletitre">
            {{ value?.maplocaletitre?.[locales[0]] }}
          </ng-container>
          <ng-container *ngIf="value?.icon">
            <img src="/assets/images/pictos/{{value.icon.picto}}.png" height="30" />
          </ng-container>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <div *ngIf="isDynamicDocumentInfo">
      <button mat-raised-button class="btn-primary" (click)="ouvrirOnglet('add')">Ajouter un champ</button>
    </div>
    <table mat-table [dataSource]="datasource" matSort matSortActive="code" class="mat-elevation-z8">
      <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <ng-container *ngIf="column !== 'delete'" class="test">
            {{ column | columnRenamePipe |uppercase }}
          </ng-container>
        </th>

        <td mat-cell *matCellDef="let element">
          <a *ngIf="column === 'delete' && !isDeleteDisabled(element)" class="mat-raised-button btn-danger"
            (click)="suprimme(element)">
            <mat-icon style="vertical-align: middle">delete</mat-icon>
          </a>
          <!-- <a *ngIf="column === 'delete' && isDynamicDocument" class="mat-raised-button" (click)="$event.stopPropagation();checkView(element); ">
            <mat-icon style="vertical-align: middle" [ngStyle]="{'opacity': element.isInDefaultView ? '1' : '0.4'}">remove_red_eye</mat-icon>
          </a> -->
          <ng-container *ngIf="column === 'icon'">
            <img src="/assets/images/pictos/{{element[column].picto}}.png" height="30" />
          </ng-container>
          <ng-container *ngIf="['mapDescriptionVl','mapdescription','maplocaletitre' ].includes(column)">
            {{ element[column]?.[locales[0]] }}
          </ng-container>

          <ng-container *ngIf="entite === 'Picto' && column === 'label'">
            {{ element?.[column]?.[locales[0]] }}
          </ng-container>

          <ng-container *ngIf="entite !== 'Picto' && column === 'label'">
            {{ element?.[column]?.['fr_FR'] ? element?.[column]?.['fr_FR'] : element?.[column]?.get('fr_FR')}}
          </ng-container>

          <ng-container
            *ngIf="column !== 'delete' && column !== 'icon'&& column !== 'mapDescriptionVl'&& column !== 'mapdescription'&& column !== 'maplocaletitre' && (entite !== 'Picto' && column !== 'label')">
            {{ getValue(element?.[column.trim()]) }}
          </ng-container>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="ouvrirOnglet(row)">
      </tr>
    </table>


  </div>
  <div class="col-lg-11" style="padding-left: 0px"
    *ngIf="!config.editMode || (!userService.userHasChampViewPermissionAccess(config.name,config.typeName))&& config.editMode">
    <ng-container>
      <ng-container *ngIf="config.label">
        <label [for]="config.id"><strong>{{ config.label }}</strong></label>
      </ng-container>
      <mat-form-field appearance="outline" style="font-size: 10px; width: 100%">
        <mat-label> Recherche {{ config.label }}</mat-label>
        <input matInput placeholder="{{ config.label }}" (keyup)="filtreMotCles($event)" [(ngModel)]="recherche" />
      </mat-form-field>
    </ng-container>

    <table mat-table [dataSource]="datasource" matSort matSortActive="code" class="mat-elevation-z8">
      <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <ng-container *ngIf="column !== 'delete'" class="test">
            {{ column | columnRenamePipe |uppercase}}
          </ng-container>
        </th>

        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="column === 'icon'">
            <img src="/assets/images/pictos/{{element[column].picto}}.png" height="30" />
          </ng-container>
          <ng-container *ngIf="column === 'mapDescriptionVl'">
            {{ element?.[column]?.[locales[0]] }}
          </ng-container>

          <ng-container
            *ngIf="column !== 'delete' && column !== 'icon'&& column !== 'mapDescriptionVl'&& column !== 'mapdescription' && column !== 'maplocaletitre' && (entite !== 'Picto' && column !== 'label')">
            {{ getValue(element?.[column],column) }}
          </ng-container>
          <ng-container *ngIf="column === 'mapdescription'">
            {{ element?.[column]?.[locales[0]] }}
          </ng-container>
          <ng-container *ngIf="column === 'maplocaletitre'">
            {{ element?.[column]?.[locales[0]] }}
          </ng-container>

          <ng-container *ngIf="entite === 'Picto' && column === 'label'">
            {{ element?.[column]?.[locales[0]] }}
          </ng-container>

          <ng-container *ngIf="entite !== 'Picto' && column === 'label'">
            {{ element?.[column]?.['fr_FR'] }}
          </ng-container>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr class="troow" mat-row *matRowDef="let row; columns: displayedColumns" (click)="ouvrirOnglet(row)"></tr>
    </table>
  </div>
</div>
